import {
    LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE
  } from './constants';

  
  
  // The auth reducer. Starting state is unauthenticated.
  // Token expiry is checked client-side in Auth.js componentDidMount (P2-E).

  export default function auth(state = {
      isFetching: false,
      isAuthenticated: false,  //Cookies.get('token') ? true : false
      authChecked: false        // true once the initial checkToken call has resolved
    }, action) {
    switch (action.type) {
      case LOGIN_REQUEST:
        return Object.assign({}, state, {
          isFetching: true,
          isAuthenticated: false,
          user: action.creds
        })
      case LOGIN_SUCCESS:
        return Object.assign({}, state, {
          isFetching: false,
          isAuthenticated: true,
          authChecked: true,
          errorMessage: ''
        })
      case LOGIN_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          isAuthenticated: false,
          authChecked: true,
          errorMessage: action.message
        })
      default:
        return state
    }
  }
  